/* nb-chat.js — Manage Zaapi chat trigger button + iframe open/close state
   Exposes window.openZaapiChat() and window.closeZaapiChat() globally.
   Hides the trigger button until the Zaapi iframe is present. */

(function () {
  'use strict';

  var IFRAME_ID = 'zcw-iframe';
  var TRIGGER_ID = 'nb-chat-trigger';
  var OPEN_CLASS = 'nb-chat-open';
  var READY_CLASS = 'nb-chat-ready';
  var pendingOpen = false;

  function getIframe() { return document.getElementById(IFRAME_ID); }
  function getTrigger() { return document.getElementById(TRIGGER_ID); }

  function showTrigger() {
    var t = getTrigger();
    if (t) t.classList.add(READY_CLASS);
  }

  function openChat() {
    var iframe = getIframe();
    if (!iframe || !iframe.contentWindow) {
      pendingOpen = true;
      // Fallback if widget never loads: reload with URL param that Zaapi handles natively
      setTimeout(function () {
        if (pendingOpen && !getIframe()) {
          var u = new URL(window.location.href);
          u.searchParams.set('zcwopen', '1');
          window.location.href = u.toString();
        }
      }, 3000);
      return;
    }
    iframe.classList.add(OPEN_CLASS);
    // Hold a fixed desktop size that fits the tallest Zaapi screen (pre-chat form).
    // Tried dynamic resize from zcw:resize but Zaapi reports a height that
    // undercounts their panel size, causing top cut-off. Empty space below the
    // input in active-chat mode is acceptable.
    // Use setProperty + 'important' to beat the default !important 0x0 clamp.
    if (window.innerWidth > 640) {
      iframe.style.setProperty('width', '380px', 'important');
      iframe.style.setProperty('height', '640px', 'important');
    }
    iframe.contentWindow.postMessage({ type: 'zcw:open-chat' }, '*');
  }

  function closeChat() {
    var iframe = getIframe();
    if (iframe) {
      iframe.classList.remove(OPEN_CLASS);
      // Reset inline sizing so default 0x0 clamp re-applies
      iframe.style.width = '';
      iframe.style.height = '';
    }
  }

  window.openZaapiChat = openChat;
  window.closeZaapiChat = closeChat;

  // Listen for messages from the Zaapi iframe
  window.addEventListener('message', function (e) {
    if (!e.data || typeof e.data !== 'object') return;
    var type = e.data.type;

    if (type === 'zcw:loaded' || type === 'zcw:widget-config-loaded') {
      showTrigger();
      if (pendingOpen) { pendingOpen = false; openChat(); }
    }

    if (type === 'zcw:close') closeChat();

    // Resize handler: re-clamp to 0 for launcher-size requests only.
    // We ignore Zaapi's panel-size resize values because they undercount the
    // panel chrome and cause top cut-off. Our fixed 640px in openChat() is
    // tall enough to fit all Zaapi screens.
    if (type === 'zcw:resize') {
      var p = e.data.payload;
      if (!p || typeof p !== 'object') return;
      var w = parseInt(p.width, 10) || 0;
      var iframe = getIframe();
      if (!iframe) return;
      if (w < 200) {
        // Launcher-size request — keep iframe clamped (we hide Zaapi's default launcher)
        closeChat();
      }
    }
  });

  // Watch for iframe injection (Zaapi adds it async after DOMContentLoaded)
  function watchForIframe() {
    var attempts = 0;
    var iv = setInterval(function () {
      attempts++;
      if (getIframe()) {
        showTrigger();
        clearInterval(iv);
      } else if (attempts > 40) {
        clearInterval(iv);
        if (window.console && console.warn) {
          console.warn('[nb-chat] Zaapi widget iframe not found after 20s');
        }
      }
    }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchForIframe);
  } else {
    watchForIframe();
  }

  // Detect sticky ATC bar and add class to body so chat button bumps above it.
  // Selectors target the actual classes used in nuvie warmelite theme.
  function detectStickyATC() {
    var sel = '.nuvie-sticky-mobile-section, .nuvie-sticky-desktop-section, ' +
              '.m-sticky-addtocart, .nb-sticky-atc-bar-wrapper';
    var bars = document.querySelectorAll(sel);
    var visible = false;
    for (var i = 0; i < bars.length; i++) {
      var b = bars[i];
      if (b.offsetParent !== null && b.offsetHeight > 20) {
        // offsetParent null = display:none ancestor; offsetHeight check filters out 0-height placeholder
        visible = true;
        break;
      }
    }
    document.body.classList.toggle('nb-has-sticky-atc', visible);
  }
  function watchStickyATC() {
    detectStickyATC();
    // Re-check on scroll/resize since sticky bars often appear/disappear with scroll
    window.addEventListener('scroll', detectStickyATC, { passive: true });
    window.addEventListener('resize', detectStickyATC, { passive: true });
    // Re-check after a short delay in case the bar is JS-injected
    setTimeout(detectStickyATC, 1500);
    setTimeout(detectStickyATC, 4000);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchStickyATC);
  } else {
    watchStickyATC();
  }

  // Intercept all WhatsApp links and route to live chat instead
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t) return;
    var a = t.closest && t.closest('a[href*="wa.me/"], a[href*="api.whatsapp.com"], a[href^="whatsapp:"]');
    if (a) {
      e.preventDefault();
      e.stopPropagation();
      openChat();
    }
  }, true);
})();
